import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import Client from '../Client/Client'
import IState from '../interfaces/IState'
import {IUserHr} from '../interfaces/IUserHr'

import {
    ActionTypes,
    GET_HR_USERS_FAILURE,
    GET_HR_USERS_REQUEST,
    GET_HR_USERS_SUCCESS
} from './ActionTypes'

export const getHrUsers = (): ThunkAction<any, any, any, any> => {
    return (dispatch: ThunkDispatch<IState, any, any>) => {
        dispatch({
            type:  GET_HR_USERS_REQUEST
        })

        return Client.getHrUsers()
            .then(
            (hrData: IUserHr[]) =>  dispatch(getHrUsersSuccess(hrData)),
                    ()=> dispatch(getHrUsersFailure())
        )
    }
}

export const getHrUsersSuccess = (
    hrData: IUserHr[]
) => {
    return {
        type: GET_HR_USERS_SUCCESS,
        payload: {
            users: hrData
        }
    }
}

const getHrUsersFailure = (): ActionTypes => {
    return {
        type: GET_HR_USERS_FAILURE
    }
}